import React, { Component, Fragment } from 'react';
import axios from 'components/AppRequest';
import { connect } from 'react-redux';
import { setUserLogged, resetRegisterFields } from 'components/actions/authActions'
import withRouter from 'components/components/common/withRouter';
import VerificationPhoneNumber from 'components/components/common/VerificationPhoneNumber';

class RegistrationFormStep3 extends Component {

  render() {
    return (
      <VerificationPhoneNumber
        isBooking={false}
        customerData={this.props.register}
        setUserLogged={this.props.setUserLogged}
        resetRegisterFields={this.props.resetRegisterFields}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    register: state.auth.register
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    { setUserLogged, resetRegisterFields }
  )(RegistrationFormStep3)
);
